import { render, staticRenderFns } from "./PrinterSettings.vue?vue&type=template&id=40bd3e74"
import script from "./PrinterSettings.vue?vue&type=script&lang=js"
export * from "./PrinterSettings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports